import { render } from "./Question.vue?vue&type=template&id=3ad9eb36&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=3ad9eb36&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad9eb36"]])

export default __exports__